import {CardGroupVo} from '~model/vo/card-group-vo';

export interface DashboardVo {
  rotas: RotaDashboardVo[];
  totalizadores: CardGroupVo[];
}

export interface RotaDashboardVo {
  id: string;
  motorista: string;
  coletas: CardGroupVo;
  entregas: CardGroupVo;
}

export const emptyDashboard = (): DashboardVo => ({rotas: [], totalizadores: []});
